export const stringListToArray = (value: string | null | undefined) => {
	if (!value) return [];
	return value.split("\n").map((s) => s.trim());
};
